import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Modal } from '../../components/Modal'
import { ModalType } from '../../states/modals/ModalType.constants'
import { HappySmileIcon } from '../../components/Icon/HappySmileIcon'
import { Text } from '../../components/Text'
import { STYLES } from '../../static/style'

const ThankYouIcon = styled(HappySmileIcon)`
  font-size: 3rem;
  color: ${STYLES.PRIMARY_COLOR};
  margin: 1rem 0;
`

const HeaderMessage = styled(Text)`
  display: block;
  font-size: ${STYLES.FONT_SIZE_XL};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const TextMessage = styled(Text)`
  display: block;
  margin: 1rem 0;
`

const StyledModal = styled(Modal)`
  text-align: center;
  padding: 2rem;
`

const ChangeRequestSubmittedModal = () => {
  const { modalType, data } = useSelector(({ modals }) => modals)
  if (modalType !== ModalType.CHANGE_REQUEST_SUBMITTED) {
    return null
  }
  const { id } = data
  const chunks = id.split('-')
  const lastChunk = chunks[chunks.length - 1]
  return (
    <StyledModal>
      <ThankYouIcon />
      <HeaderMessage>Thank you for submitting a change request.</HeaderMessage>

      <TextMessage>Reference #: {lastChunk}</TextMessage>

      <TextMessage>
        One of our team members will review this request as soon as possible.
      </TextMessage>
    </StyledModal>
  )
}

export { ChangeRequestSubmittedModal }
